module.exports = __webpack_public_path__ + "static/media/spongeCake.a1772b6c.jpg";